<div style="margin-bottom: 20px">
  <app-feature-flag-tabs>
    <sbnb-back-button
      navTabs
      class="hidden sbnbDesktop:block"
      *ngIf="!onboardingStatus"
      [routerLink]="['/properties']"
      [disableRedirect]="true"></sbnb-back-button>
    <sbnb-back-button
      *ngIf="!onboardingStatus"
      [routerLink]="['/properties']"
      [disableRedirect]="true"></sbnb-back-button>
  </app-feature-flag-tabs>
</div>

<div *ngIf="onboardingStatus" fxLayout fxLayoutGap="8px" class="navigation__back" (click)="leaveOnboarding()">
  <img src="/assets/iconography/back.svg" alt="Back" />
  <span>Back to rules overview</span>
</div>

<ng-container *ngIf="onboardingStatus">
  <ng-container *ngFor="let nav of onboardingNavigation">
    <ng-container *ngIf="!nav.permission || (perms$.hasAccessTo(nav.permission) | async)">
      <h4
        fxLayoutAlign="start center"
        fxLayoutGap="10px"
        [class.not-clickable]="nav.children?.length > 0"
        (click)="nav.children?.length > 0 ? null : changeActiveComponent(nav.id, nav)"
        [class.active]="nav.id === activeComponent">
        <img
          *ngIf="!nav.useIconComponent"
          class="property__icon"
          src="/assets/iconography/{{ nav.icon }}{{ nav.id === activeComponent ? '-active' : null }}.svg" />
        <sbnb-icon
          *ngIf="nav.useIconComponent"
          [icon]="nav.icon"
          [size]="18"
          [ngClass]="{
            'text-smoke-darker': nav.id !== activeComponent,
            'text-raspberry-darker': nav.id === activeComponent
          }"></sbnb-icon>
        <span fxFlex>{{ nav.heading }}</span>
      </h4>
    </ng-container>
  </ng-container>
</ng-container>

<ng-container *ngIf="!onboardingStatus">
  <div *ngFor="let nav of navigation" [hidden]="nav.hidden">
    <ng-container *ngIf="!nav.permission || (perms$.hasAccessTo(nav.permission) | async)">
      <div [matTooltip]="propertyMuted ? 'Unavailable for muted properties.' : ''">
        <h4
          fxLayoutAlign="start center"
          fxLayoutGap="10px"
          (click)="changeActiveComponent(nav.id, nav)"
          [class.active]="nav.id === activeComponent || nav.id === activeParent"
          [class.pointer-events]="!nav.allowedWhenMuted && propertyMuted">
          <img
            *ngIf="!nav.useIconComponent"
            class="property__icon"
            src="/assets/iconography/{{ nav.icon }}{{ nav.id === activeParent ? '-active' : null }}.svg" />
          <sbnb-icon
            *ngIf="nav.useIconComponent"
            [icon]="nav.icon"
            [size]="18"
            [ngClass]="{
              'text-smoke-darker': nav.id !== activeComponent,
              'text-raspberry-darker': nav.id === activeComponent
            }"></sbnb-icon>
          <span fxFlex>{{ nav.heading }}</span>
          <sbnb-badge *ngIf="nav.new" context="positive">new</sbnb-badge>
          <sbnb-badge *ngIf="nav.badge" context="positive">{{ nav.badge }}</sbnb-badge>
        </h4>
      </div>

      <div
        *ngIf="
          nav.children &&
          nav.children.length > 0 &&
          (nav.id === activeParent || (!nav.fragmentBased && featureFlagMobileNavTabsEnabled && deviceDetectionService.$isMobile | async))
        "
        class="subnav__container">
        <ng-container *ngFor="let child of nav.children">
          <div
            *ngIf="!nav.permission || (perms$.hasAccessTo(nav.permission) | async)"
            [hidden]="child.hidden"
            [matTooltip]="propertyMuted ? 'Unavailable for muted properties.' : ''">
            <a
              class="clickable"
              [class.active]="child.id === activeComponent"
              [class.pointer-events]="!child.allowedWhenMuted && propertyMuted"
              (click)="changeActiveComponentFromChild(child.id, nav)">
              {{ child.heading }}
            </a>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-container>
